import type { Middleware } from "@reduxjs/toolkit";

import { ErrorTypes } from "@v1/constants/error-types";
import { trackError } from "@v2/features/infra/analytics/tracking";

const errorMiddleware: Middleware = ({ dispatch }) => {
  return (next) => {
    return (action) => {
      try {
        return next(action);
      } catch (error) {
        console.error(error);
        trackError(error, { action });
        return dispatch({
          type: "SET_ERROR",
          payload: {
            message: "An unknown error has occurred. Try refreshing the page.",
            type: ErrorTypes.ACTIONABLE__RELOAD,
          },
        });
      }
    };
  };
};

export default errorMiddleware;
